import React, { useCallback } from 'react';
/* eslint import/no-extraneous-dependencies: ["error", {"devDependencies": true}] */
import { Translate, useTranslate, Price as Currency } from '@pegasus/translation';
import { Text, Preset, ShadeColor } from '@lux/text';
import { ButtonType } from '@lux/buttons';
import { track, getTrackingDataReserveAgain } from '../../../../../lib/tracking';
import { StockStatus as ArticleStockStatus, } from '../../../Cart/types';
import { Header, HeaderText, Description, Content, Title, Size, Price } from '../CartItem/styles';
import { RecoveredItemWrapper, ReserveItem, ReserveAgain, Image } from './styles';
const ADD_TO_CART_SOURCE = 'recovered cart'; // being used for tracking
const stockStatusReason = {
    [ArticleStockStatus.AVAILABLE]: 'expiredReservation',
    [ArticleStockStatus.RESERVED]: 'reservedOther',
    [ArticleStockStatus.SOLD_OUT]: 'outOfStock',
};
const RecoveredItem = ({ name, configSku, simpleSku, campaignIdentifier, brand, price, specialPrice, size, imageUrl, stockStatus, languageCode, onItemClick, onItemReserveAgain, }) => {
    const translate = useTranslate();
    const successFlashMessage = translate('articleAddedIntoCart');
    const recoveredCartItem = {
        brand,
        imageUrl,
        name,
        price,
        specialPrice,
        size,
        configSku,
        simpleSku,
        stockStatus,
        campaignIdentifier,
        languageCode,
    };
    const onReserveAgain = useCallback(async () => {
        await onItemReserveAgain({
            simpleSku,
            configSku,
            campaignIdentifier,
            itemSize: size,
            addToCartSource: ADD_TO_CART_SOURCE,
            successFlashMessage,
        });
        track('cart', getTrackingDataReserveAgain(recoveredCartItem, ADD_TO_CART_SOURCE));
    }, [simpleSku, configSku, campaignIdentifier, size]);
    const handleItemClick = useCallback(() => onItemClick(configSku, campaignIdentifier), [
        configSku,
        campaignIdentifier,
    ]);
    return (React.createElement(RecoveredItemWrapper, null,
        React.createElement(Header, null,
            React.createElement(HeaderText, { onClick: handleItemClick, href: `/campaigns/${campaignIdentifier}/articles/${configSku}` },
                React.createElement(Text, { preset: Preset.S, color: ShadeColor.dark40, bold: true }, brand))),
        React.createElement(Content, { onClick: handleItemClick, 
            // @TODO consider using the articleUrl property provided by the stockcart api
            href: `/campaigns/${campaignIdentifier}/articles/${configSku}` },
            React.createElement(Image, { src: imageUrl, alt: name }),
            React.createElement(Description, null,
                React.createElement(Title, null,
                    React.createElement(Text, { preset: Preset.XS, color: ShadeColor.dark40 }, name)),
                React.createElement(Size, null,
                    React.createElement(Text, { preset: Preset.XS, color: ShadeColor.dark40 },
                        React.createElement(Translate, { message: "size" }),
                        ': '),
                    React.createElement(Text, { preset: Preset.XS, color: ShadeColor.dark40 }, size)),
                React.createElement(Price, null,
                    React.createElement(Text, { preset: Preset.S, color: ShadeColor.dark40, bold: true },
                        React.createElement(Currency, { cents: String(specialPrice), languageCode: languageCode }))))),
        React.createElement(ReserveItem, null,
            React.createElement(Text, { preset: Preset.S, color: ShadeColor.dark80, bold: true },
                React.createElement(Translate, { message: stockStatusReason[stockStatus] })),
            stockStatus === ArticleStockStatus.AVAILABLE && (React.createElement(ReserveAgain, { onClick: onReserveAgain, buttonType: ButtonType.contextual },
                React.createElement(Translate, { message: "reserveAgain" }))))));
};
export default RecoveredItem;
//# sourceMappingURL=index.js.map